import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appc-badge-with-close',
  templateUrl: './badge-with-close.component.html',
  styleUrls: ['./badge-with-close.component.scss'],
  standalone: false,
})
export class BadgeWithCloseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
